import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.weak-map.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Struct } from '@polkadot/types-codec';
import { assert } from '@polkadot/util';
import { toV10 } from "./v9/toV10.js";
import { toV11 } from "./v10/toV11.js";
import { toV12 } from "./v11/toV12.js";
import { toV13 } from "./v12/toV13.js";
import { toV14 } from "./v13/toV14.js";
import { toLatest } from "./v14/toLatest.js";
import { MagicNumber } from "./MagicNumber.js";
import { getUniqTypes as _getUniqTypes, toCallsOnly } from "./util/index.js";
var LATEST_VERSION = 14;
/**
 * @name MetadataVersioned
 * @description
 * The versioned runtime metadata as a decoded structure
 */

var _converted = /*#__PURE__*/new WeakMap();

var _assertVersion = /*#__PURE__*/new WeakMap();

var _getVersion = /*#__PURE__*/new WeakMap();

var _metadata = /*#__PURE__*/new WeakMap();

export var MetadataVersioned = /*#__PURE__*/function (_Struct) {
  _inherits(MetadataVersioned, _Struct);

  var _super = _createSuper(MetadataVersioned);

  function MetadataVersioned(registry, value) {
    var _this;

    _classCallCheck(this, MetadataVersioned);

    // console.time('MetadataVersioned')
    _this = _super.call(this, registry, {
      magicNumber: MagicNumber,
      metadata: 'MetadataAll'
    }, value); // console.timeEnd('MetadataVersioned')

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _converted, {
      writable: true,
      value: new Map()
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _assertVersion, {
      writable: true,
      value: function value(version) {
        assert(_this.version <= version, function () {
          return "Cannot convert metadata from version ".concat(_this.version, " to ").concat(version);
        });
        return _this.version === version;
      }
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _getVersion, {
      writable: true,
      value: function value(version, fromPrev) {
        var asCurr = "asV".concat(version);
        var asPrev = version === 'latest' ? "asV".concat(LATEST_VERSION) : "asV".concat(version - 1);

        if (version !== 'latest' && _classPrivateFieldGet(_assertThisInitialized(_this), _assertVersion).call(_assertThisInitialized(_this), version)) {
          return _classPrivateFieldGet(_assertThisInitialized(_this), _metadata).call(_assertThisInitialized(_this))[asCurr];
        }

        if (!_classPrivateFieldGet(_assertThisInitialized(_this), _converted).has(version)) {
          _classPrivateFieldGet(_assertThisInitialized(_this), _converted).set(version, fromPrev(_this.registry, _this[asPrev], _this.version));
        }

        return _classPrivateFieldGet(_assertThisInitialized(_this), _converted).get(version);
      }
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _metadata, {
      writable: true,
      value: function value() {
        return _this.getT('metadata');
      }
    });

    return _this;
  }

  _createClass(MetadataVersioned, [{
    key: "registry",
    get: function get() {
      return _get(_getPrototypeOf(MetadataVersioned.prototype), "registry", this);
    }
    /**
     * @description Returns the wrapped metadata as a limited calls-only (latest) version
     */

  }, {
    key: "asCallsOnly",
    get: function get() {
      return new MetadataVersioned(this.registry, {
        magicNumber: this.magicNumber,
        metadata: this.registry.createTypeUnsafe('MetadataAll', [toCallsOnly(this.registry, this.asLatest), LATEST_VERSION])
      });
    }
    /**
     * @description Returns the wrapped metadata as a V9 object
     */

  }, {
    key: "asV9",
    get: function get() {
      _classPrivateFieldGet(this, _assertVersion).call(this, 9);

      return _classPrivateFieldGet(this, _metadata).call(this).asV9;
    }
    /**
     * @description Returns the wrapped values as a V10 object
     */

  }, {
    key: "asV10",
    get: function get() {
      return _classPrivateFieldGet(this, _getVersion).call(this, 10, toV10);
    }
    /**
     * @description Returns the wrapped values as a V11 object
     */

  }, {
    key: "asV11",
    get: function get() {
      return _classPrivateFieldGet(this, _getVersion).call(this, 11, toV11);
    }
    /**
     * @description Returns the wrapped values as a V12 object
     */

  }, {
    key: "asV12",
    get: function get() {
      return _classPrivateFieldGet(this, _getVersion).call(this, 12, toV12);
    }
    /**
     * @description Returns the wrapped values as a V13 object
     */

  }, {
    key: "asV13",
    get: function get() {
      return _classPrivateFieldGet(this, _getVersion).call(this, 13, toV13);
    }
    /**
     * @description Returns the wrapped values as a V14 object
     */

  }, {
    key: "asV14",
    get: function get() {
      return _classPrivateFieldGet(this, _getVersion).call(this, 14, toV14);
    }
    /**
     * @description Returns the wrapped values as a latest version object
     */

  }, {
    key: "asLatest",
    get: function get() {
      return _classPrivateFieldGet(this, _getVersion).call(this, 'latest', toLatest);
    }
    /**
     * @description The magicNumber for the Metadata (known constant)
     */

  }, {
    key: "magicNumber",
    get: function get() {
      return this.getT('magicNumber');
    }
    /**
     * @description the metadata version this structure represents
     */

  }, {
    key: "version",
    get: function get() {
      return _classPrivateFieldGet(this, _metadata).call(this).index;
    }
  }, {
    key: "getUniqTypes",
    value: function getUniqTypes(throwError) {
      return _getUniqTypes(this.registry, this.asLatest, throwError);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      // HACK(y): ensure that we apply the aliases if we have not done so already, this is
      // needed to ensure we have the correct overrides (which is only applied in toLatest)
      // eslint-disable-next-line no-unused-expressions
      this.asLatest;
      return _get(_getPrototypeOf(MetadataVersioned.prototype), "toJSON", this).call(this);
    }
  }]);

  return MetadataVersioned;
}(Struct);